// extracted by mini-css-extract-plugin
module.exports = {"component":"my-trip-products-webview_component__nBQ8A"};